import { styled } from 'styled-components';

import { cssBreakpoints, gutterWidth } from '#/theme/theme';

export const CmsCategoryHighlightBlockCategory_Box_1 = styled.div`
  padding: ${gutterWidth / 4}px;
  width: 100%;
  flex: 0 0 auto;

  @media all and (min-width: ${cssBreakpoints.smUp}) {
    width: 33.33%;
  }

  @media all and (min-width: ${cssBreakpoints.smUp}) {
    padding: ${gutterWidth / 2}px;
  }
`;
